import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchProcessingFactoryDetail(id) {
  const { data: raw } = await request.get(`/mom/processing-factory/${id}`);
  return parseVer4DetailResponse(raw);
}
